import CrudService from "@/services/shared/http/CrudService";

export default class DescriptionService extends CrudService {
  constructor(params = {}) {
    super("descriptions", params);
  }
}
